import "/home/deployer/apps/visa_management/shared/bundle/ruby/2.7.0/gems/social-share-button-1.2.4/app/assets/javascripts/social-share-button.coffee"
